export default __webpack_public_path__ + "assets/images/de6bbd66d2fbc39258ebf77f7fce737c.png";